export default {
    methods: {
        formatPhone: function(phone){
            if (!phone || phone.trim().length != 10) {
                return phone;
            }   
            phone = phone.trim();
            return "(" + phone.substr(0,3) + ") " + phone.substr(3,3) + "-" + phone.substr(6,4); 
        },
        unformatPhone: function(phone) {
            // if (!phone || phone.trim().length != 10) {
            //     return phone;
            // }
            if (!phone) {
                return "";
            }
            return phone.replace(/\+/gi,'').replace(/-/gi,'').replace(/\(/gi,'').replace(/\)/gi,'').replace(' ','').trim();
        }
    }
};